import { computed } from "vue";
import { useI18n } from "vue-i18n";

export function useSortOptions(type) {
    const { t } = useI18n();

    const sortOptions = computed(() => {
        switch (type) {
            case "assets":
                return [
                    {
                        id: "name",
                        value: "name",
                        label: t("components.sorting.name.label"),
                    },
                    {
                        id: "identifier",
                        value: "identifier",
                        label: t("components.sorting.identifier.label"),
                    },
                    {
                        id: "space.name",
                        value: "space",
                        label: t("components.sorting.space.label"),
                    },
                    {
                        id: "category.name",
                        value: "category",
                        label: t("components.sorting.category.label"),
                    },
                    {
                        id: "group.name",
                        value: "group",
                        label: t("components.sorting.asset_group.label"),
                    },
                    {
                        id: "brand",
                        value: "brand",
                        label: t("components.sorting.brand.label"),
                    },
                    {
                        id: "serial_number",
                        value: "serial_number",
                        label: t("components.sorting.serial_number.label"),
                    },
                    {
                        id: "files",
                        value: "files",
                        label: t("components.sorting.files.label"),
                    },
                    {
                        id: "qr_codes",
                        value: "qr_codes",
                        label: t("components.sorting.qr_codes.label"),
                    },
                    {
                        id: "supplier",
                        value: "supplier",
                        label: t("components.sorting.supplier.label"),
                    },
                    {
                        id: "created_at",
                        value: "created_at",
                        label: t("components.sorting.created_at.label"),
                    },
                    {
                        id: "purchased_at",
                        value: "purchased_at",
                        label: t("components.sorting.purchased_at.label"),
                    },
                ];
            case "files":
                return [
                    {
                        id: "title",
                        value: "title",
                        label: t("components.sorting.title.label"),
                    },
                    {
                        id: "public",
                        value: "public",
                        label: t("components.sorting.public.label"),
                    },
                    {
                        id: "created_at",
                        value: "created_at",
                        label: t("components.sorting.created_at.label"),
                    },
                    {
                        id: "expiration_date",
                        value: "expiration_date",
                        label: t("components.sorting.expiration_date.label"),
                    },
                    {
                        id: "reminder_date",
                        value: "reminder_date",
                        label: t("components.sorting.reminder_date.label"),
                    },
                ];
            case "recurring_tasks":
                return [
                    {
                        id: "description",
                        value: "description",
                        label: t("components.sorting.description.label"),
                    },
                    {
                        id: "space.name",
                        value: "space.name",
                        label: t("components.sorting.linked_to.label"),
                    },
                    {
                        id: "category.name",
                        value: "category.name",
                        label: t("components.sorting.category.label"),
                    },
                    {
                        id: "priority",
                        value: "priority",
                        label: t("components.sorting.priority.label"),
                    },
                    {
                        id: "assignee",
                        value: "assignee",
                        label: t("components.sorting.assignee.label"),
                    },
                    {
                        id: "created_at",
                        value: "created_at",
                        label: t("components.sorting.created_at.label"),
                    },
                ];

            default:
                // Tasks
                return [
                    {
                        id: "description",
                        value: "description",
                        label: t("components.sorting.description.label"),
                    },
                    {
                        id: "priority",
                        value: "priority",
                        label: t("components.sorting.priority.label"),
                    },
                    {
                        id: "category",
                        value: "category",
                        label: t("components.sorting.category.label"),
                    },
                    {
                        id: "created_at",
                        value: "created_at",
                        label: t("components.sorting.created_at.label"),
                    },
                    {
                        id: "scheduled_for",
                        value: "scheduled_for",
                        label: t("components.sorting.scheduled_for.label"),
                    },
                    {
                        id: "completed_at",
                        value: "completed_at",
                        label: t("components.sorting.completed_at.label"),
                    },
                ];
        }
    });

    return {
        sortOptions,
    };
}
